import React, { useEffect, useState } from 'react'
import { seeReplyComments, createReplyComment, deleteReplyComment } from '../../actions/commentActions'
import { connect, useDispatch } from 'react-redux'
import MoreText from '../../containers/MoreText';
import { useHistory } from "react-router-dom";
import { fileUploadComment } from '../../actions/fileUploadActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import CreateNewComment from './CreateNewComment';
import Comment from '../../containers/Post/Comment/Comment';
import { createReaction } from '../../actions/reactionActions';
import localStorage from '../../utils/hooks/useLocalStorage';

const CreateReplyComment = ({ isProfessional, commentID, fileUploadComment, seeReplyComments, isMark, replyCommentsList, createReplyComment, deleteReplyComment, isLoading }) => {

    const history = useHistory()
    const dispatch = useDispatch()
    const [replyText, setReplyText] = useState('')
    const [dataFile, setDataFile] = useState(null)
    const [isOnlyAudio, setIsOnlyAudio] = useState(false)
    const [isShowAudio, setIsShowAudio] = useState(false)
    const [isShowGif, setIsShowGif] = useState(false)
    const [isOnlyGif, setIsOnlyGif] = useState(false)
    const [isShowReportPost, setIsShowReportPost] = useState(false)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeReplyComments(commentID)
        })

    }, [commentID])

    const auto_height = (e) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }
    const selectReportPost = (e) => {
        e.stopPropagation()
        setIsShowReportPost(!isShowReportPost)
    }
    const myCallback = (event, code) => {
        setReplyText(replyText + code.emoji)
    }

    const onFileChange = (event) => {
        var filesTarget = event.target.files
        console.log()
        filesTarget[0].url = URL.createObjectURL(event.target.files[0])
        setDataFile({ [filesTarget[0].url]: { name: filesTarget[0].name, url: filesTarget[0].url, file: filesTarget[0] } })

    }

    const selectGif = (e) => {
        e.stopPropagation()
        setIsShowGif(!isShowGif)
    }

    const selectAudio = (e) => {
        e.stopPropagation()
        setIsShowAudio(!isShowAudio)
    }
    const createReactionBubble = (id) => {
        dispatch(createReaction(id, 'RCT01', 0, false, false, 'comment', false))
    }
    const createReactionRecycle = (id) => {
        dispatch(createReaction(id, 'RCT02', 0, false, false, 'comment', false))
    }

    if (isLoading)
        return <div>Cargando...</div>
    if (!isLoading) {
        return (
            <div>
                {
                    localStorage().getItem("typeProfile") != "warehouse" && (//TodoEcoCeoSocial
                        <CreateNewComment isReplyComment={true} postID={commentID} />
                    )
                }

                <div className='row row-gap'>
                    {replyCommentsList.map((comment, index) => {
                        // var dataUser = comment && (comment.userID ? comment.userID : comment.franchiseID ? comment.franchiseID : {})
                        var dataUser = comment && (comment.userID ? comment.userID : comment.franchiseID ? comment.franchiseID : (comment.representativeID && comment.representativeID.userID) ? comment.representativeID.userID : {})

                        var contentModal = null
                        console.log();

                        return (
                            <Comment
                                key={comment?._id}
                                isReplyComment={true}
                                createReactionBubble={() => createReactionBubble(comment._id)}
                                createReactionRecycle={() => createReactionRecycle(comment._id)}
                                reactions={comment.reactions}
                                image={comment.image}
                                audio={comment.audio}
                                video={comment.video}
                                idCommentator={dataUser._id}
                                secondName={dataUser.lastname}
                                firstName={dataUser.name ? dataUser.name : dataUser.socialReason}
                                srcImage={dataUser.picture && dataUser.picture.url ? dataUser.picture.url.small : dataUser.picture}
                                type={
                                    comment.userID ? "EcoAmigo" : comment.franchiseID ? "EcoTienda" : comment.representativeID ? "EcoMaster" : ""
                                }
                                comment={comment.text}
                                commentId={comment?._id}
                            />
                        )

                    })}
                </div >
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        replyCommentsList: state.comments.replyComments,
        isLoading: state.comments.isLoadingReplyComments,
        isLoadingLikePost: state.comments.isLoadingLikePost
    }
}


export default connect(mapStateToProps, { createReplyComment, deleteReplyComment, fileUploadComment, seeReplyComments })(CreateReplyComment)
